export const getEditableZoneName = (name) => {
  if (!name) return '';
  return name.replace(/^Zone\s+/i, '').trim();
};

export const ensureZonePrefix = (name) => {
  if (!name) return 'Zone ';
  if (name.match(/^Zone\s+/i)) {
    return name;
  }
  return `Zone ${name}`;
};

export const extractNumericFromZoneName = (name) => {
  if (!name) return null;
  const editableName = getEditableZoneName(name);
  const numericMatch = editableName.match(/^(\d+)$/);
  if (numericMatch) {
    return parseInt(numericMatch[1], 10);
  }
  return null;
};

export const getNextZoneName = (zones) => {
  const existingNumbers = zones
    .map(zone => {
      const zoneName = zone.zoneName || zone.name || '';
      return extractNumericFromZoneName(zoneName);
    })
    .filter(num => num !== null)
    .sort((a, b) => a - b);

  if (existingNumbers.length === 0) {
    return ensureZonePrefix('01');
  }

  const maxNumber = existingNumbers[existingNumbers.length - 1];
  const minNumber = existingNumbers[0];

  let nextNumber;
  if (minNumber > 1 && minNumber <= 3) {
    nextNumber = 1;
  } else if (minNumber > 3) {
    nextNumber = maxNumber + 1;
  } else if (minNumber === 1) {
    if (existingNumbers.length > 1 && existingNumbers[1] === 2) {
      nextNumber = maxNumber + 1;
    } else if (maxNumber <= 3) {
      nextNumber = 2;
    } else {
      nextNumber = maxNumber + 1;
    }
  } else {
    nextNumber = maxNumber + 1;
  }

  const formattedNumber = nextNumber < 100
    ? nextNumber.toString().padStart(2, '0')
    : nextNumber.toString();

  return ensureZonePrefix(formattedNumber);
};

export const transformZoneFromAPI = (apiZone) => {
  return {
    id: apiZone.id,
    zoneName: apiZone.name,
    name: apiZone.name,
    ranges: (apiZone.zone_ranges || []).map(range => ({
      id: range.id,
      rangeStart: range.start_location || '',
      rangeEnd: range.end_location || ''
    })),
    createdAt: apiZone.created_at,
    updatedAt: apiZone.updated_at
  };
};

export const transformZoneToAPI = (frontendZone) => {
  const zoneName = frontendZone.zoneName || frontendZone.name || '';
  const zone_ranges_attributes = (frontendZone.ranges || [])
    .filter(range => {
      if (range._destroy) return true;
      return (range.rangeStart && range.rangeStart.trim()) || (range.rangeEnd && range.rangeEnd.trim());
    })
    .map(range => {
      const rangeData = {
        start_location: range.rangeStart || '',
        end_location: range.rangeEnd || ''
      };

      if (range.id) {
        rangeData.id = range.id;
      }

      if (range._destroy) {
        rangeData._destroy = true;
      }

      return rangeData;
    });

  return {
    zone: {
      name: zoneName,
      zone_ranges_attributes
    }
  };
};
